<button mat-icon-button [matMenuTriggerFor]="userActions">
  <div class="w-8 h-8 rounded-full avatar" [class]="'avatar-' + user.avatar_color">{{ user.initials }}</div>
</button>

<mat-menu xPosition="before" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Signed in as</span>
      <span class="mt-1.5 text-md font-medium">{{ user.first_name }} {{ user.last_name }}</span>
      <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="logOut()">
    <mat-icon [svgIcon]="'hero_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Log out</span>
  </button>
</mat-menu>
